import { render, staticRenderFns } from "./LegitimateInterest.vue?vue&type=template&id=b1c1abde&"
import script from "./LegitimateInterest.vue?vue&type=script&lang=js&"
export * from "./LegitimateInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports